import ko from 'knockout';
import _ from 'lodash';
import templateMarkup from 'raw-loader!./share-panel-adv-modal.html';
import '../../app/bindings/ko-bindinghandler-tokenfield';
import PreferenceService from "../../services/preference.service";
import Selectr from 'mobius1-selectr/src/selectr';
import DashboardService from '../../modules/assurance/services/dashboard.service';
import DashboardDataService from '../dragdrop-grid/data/dashboard.service';
import PanelOptionsService from '../../modules/assurance/dialogs/panel-options/panel-options.service';

const selectrElements = [
  {
    elementId: 'panelAdv-fromOrgSelector',
    placeholder: 'Select an Org...'
  },
  {
    elementId: 'panelAdv-fromUserSelector',
    placeholder: 'Select a User...'
  },
  {
    elementId: 'panelAdv-fromAppSelector',
    placeholder: 'Select an App and View...'
  },
  {
    elementId: 'panelAdv-fromDashboardSelector',
    placeholder: 'Select Dashboards...'
  },
  {
    elementId: 'panelAdv-toOrgSelector',
    placeholder: 'Select an Org...'
  },
  {
    elementId: 'panelAdv-toUserSelector',
    placeholder: 'Select a User...'
  },
  {
    elementId: 'panelAdv-toAppSelector',
    placeholder: 'Select an App and View...'
  },
  {
    elementId: 'panelAdv-toDashboardSelector',
    placeholder: 'Select Dashboards...'
  },
  {
    elementId: 'panelAdv-panelSelector',
    placeholder: 'Select Panels...'
  },
];
function elementsExist () {
  let elementsExist = true;
  selectrElements.forEach(function(element) {
    let id = element.elementId;
    let search = document.getElementById(id);
    if (!search) {
      elementsExist = false;
    }
  });
  return elementsExist;
}
function SharePanelAdv(params) {
  let self = this;

  if (!_.has(params, 'signals.onShow') || !_.has(params, 'signals.onSave')) {
    throw new Error('SharePanelAdv:: Missing required signals: show, save');
  }

  const HISTORICAL2_PANEL_TYPES = {
    DISTRIBUTION: 'Distribution',
    KPI: 'KPIPanel',
    SUMMARY: 'SummaryPanel',
    TREND: 'Trend'
  };

  self.signals = params.signals;
  self.signals.onShow.add(_.bind(self.show, self));
  self.signals.onSave.add(_.bind(self.save, self));

  self.updateError = ko.observable();
  self.hasUpdateError = ko.pureComputed(function() {
    return !_.isEmpty(self.updateError());
  });

  self.panelsMap = {};
  self.showAppSelectr = ko.observable(true); // IMPORTANT! this needs to default to true for Selectr to initialize properly

  if (elementsExist()) {
    self.fromOrgSelctr = new Selectr('#panelAdv-fromOrgSelector', {
      defaultSelected: false,
      placeholder: 'Select an Org...'
    });

    self.fromUserSelctr = new Selectr('#panelAdv-fromUserSelector', {
      defaultSelected: false,
      placeholder: 'Select a User...'
    });

    self.fromAppSelctr = new Selectr('#panelAdv-fromAppSelector', {
      allowDeselect: true,
      clearable: true,
      defaultSelected: false,
      placeholder: 'Select an App and View...'
    });

    self.fromDashboardSelctr = new Selectr('#panelAdv-fromDashboardSelector', {
      defaultSelected: false,
      placeholder: 'Select Dashboards...'
    });

    self.toOrgSelctr = new Selectr('#panelAdv-toOrgSelector', {
      defaultSelected: false,
      placeholder: 'Select a Org...'
    });

    self.toUserSelctr = new Selectr('#panelAdv-toUserSelector', {
      defaultSelected: false,
      placeholder: 'Select a User...'
    });

    self.toAppSelctr = new Selectr('#panelAdv-toAppSelector', {
      allowDeselect: true,
      clearable: true,
      defaultSelected: false,
      placeholder: 'Select an App and View...'
    });

    self.toDashboardSelctr = new Selectr('#panelAdv-toDashboardSelector', {
      defaultSelected: false,
      placeholder: 'Select Dashboards...'
    });

    self.panelSelctr = new Selectr('#panelAdv-panelSelector', {
      defaultSelected: false,
      placeholder: 'Select Panels...'
    });

    self.fromUserSelctr.on('selectr.select', function(option) {
      self.fromAppSelctr.clear();
      self.fromAppSelctr.reset(); // technically I don't need to do this, but it make loading easier
      self.updateError('');
    });

    self.fromOrgSelctr.on('selectr.select', function(option) {
      self.fromUserSelctr.clear();
      self.fromUserSelctr.removeAll();

      self.toOrgSelctr.setValue(self.fromOrgSelctr.getValue());
      DashboardService.fetchUsersForOrgTemp(self.fromOrgSelctr.getValue()).then(users => {
        _.forEach(users, user => {
          if (!user.deleted) {
            self.fromUserSelctr.add({ value: user.id, text: user.id + "." + user.name })
          }
        })
      });
    });

    self.toOrgSelctr.on('selectr.select', function(option) {
      self.toUserSelctr.clear();
      self.toUserSelctr.removeAll();
      DashboardService.fetchUsersForOrgTemp(self.toOrgSelctr.getValue()).then(users => {
        _.forEach(users, user => {
          if (!user.deleted) {
            self.toUserSelctr.add({ value: user.id, text: user.id + "." + user.name })
          }
        })
      });
    });

    self.fromAppSelctr.on('selectr.select', loadFromUserTabs);
    self.fromAppSelctr.on('selectr.deselect', loadFromUserTabs);
    self.toAppSelctr.on('selectr.select', loadToUserTabs);
    self.toAppSelctr.on('selectr.deselect', loadToUserTabs);


    self.fromUserSelctr.on('selectr.select', loadFromUserTabs);
    self.fromUserSelctr.on('selectr.deselect', loadFromUserTabs);
    self.toUserSelctr.on('selectr.select', loadToUserTabs);
    self.toUserSelctr.on('selectr.deselect', loadToUserTabs);

    self.fromDashboardSelctr.on('selectr.select', loadPanels);
    self.fromDashboardSelctr.on('selectr.deselect', loadPanels);

    self.toUserSelctr.on('selectr.change', function(option) {
      self.updateError('');
    });
  }

  function loadFromUserTabs(option) {
    let appView = self.showAppSelectr() ? self.fromAppSelctr.getValue() : self.appViewData[0].value;
    self.fromDashboardSelctr.clear();
    self.fromDashboardSelctr.removeAll();
    self.updateError('');
    if (appView) {
      let appViewArray = appView.split('/');
      let userId = self.fromUserSelctr.getValue();
      if (userId) {
        PreferenceService.getTabsForOrg(appViewArray[0], appViewArray[1], self.fromOrgSelctr.getValue(), userId).then(tabList => {
          _.forEach(tabList, tab => {
            self.fromDashboardSelctr.add({ value: tab.id, text: tab.name })
          })
        });
      }
    }
  }

  function loadToUserTabs(option) {
    let appView = self.showAppSelectr() ? self.toAppSelctr.getValue() : self.appViewData[0].value;
    self.toDashboardSelctr.clear();
    self.toDashboardSelctr.removeAll();
    self.updateError('');
    if (appView) {
      let appViewArray = appView.split('/');
      let userId = self.toUserSelctr.getValue();
      if (userId) {
        PreferenceService.getTabsForOrg(appViewArray[0], appViewArray[1], self.toOrgSelctr.getValue(), userId).then(tabList => {
          _.forEach(tabList, tab => {
            self.toDashboardSelctr.add({ value: tab.id, text: tab.name })
          })
        });
      }
    }
  }

  function loadPanels() {
    let appView = self.showAppSelectr() ? self.fromAppSelctr.getValue() : self.appViewData[0].value;
    let userId = self.fromUserSelctr.getValue();
    self.panelSelctr.clear();
    self.panelSelctr.removeAll();
    self.panelsMap = {};
    self.updateError('');
    if (appView) {
      let appViewArray = appView.split('/');
      let tabId = self.fromDashboardSelctr.getValue();
      if (tabId) {
        PreferenceService.getUserTabPanels(userId, appViewArray[0], appViewArray[1], tabId).then(panelList => {
          let datasetPanels = [];
          let kpiPanels = [];
          let trendPanels = [];
          let summaryPanels = [];
          let distributionPanels = [];
          _.forEach(panelList, panel => {
            let title = panel.params.options.title ?
                        panel.params.options.title : panel.params.options.panelHeader ?
                                                     panel.params.options.panelHeader : 'unnamed panel';
            let selectrData = { value: panel.id, text: title };
            self.panelsMap[panel.id] = panel;
            // assurance
            if (self.appId === 'assurance') {
              if (panel.type === PanelOptionsService.DATASET_TYPE.panelType) datasetPanels.push(selectrData);
              if (panel.type === PanelOptionsService.KPI_TYPE.panelType) kpiPanels.push(selectrData);
              if (panel.type === PanelOptionsService.TREND_TYPE.panelType) trendPanels.push(selectrData);
            } else {
              // historical2 / workspace insights
              if (panel.type === HISTORICAL2_PANEL_TYPES.DISTRIBUTION) distributionPanels.push(selectrData);
              if (panel.type === HISTORICAL2_PANEL_TYPES.KPI) kpiPanels.push(selectrData);
              if (panel.type === HISTORICAL2_PANEL_TYPES.SUMMARY) summaryPanels.push(selectrData);
              if (panel.type === HISTORICAL2_PANEL_TYPES.TREND) trendPanels.push(selectrData);
            }
          });

          let data = [];

          if (datasetPanels.length) {
            datasetPanels.sort(sortFunc);
            data.push({
              text: 'Dataset Panels',
              children: datasetPanels
            });
          }

          if (distributionPanels.length) {
            distributionPanels.sort(sortFunc);
            data.push({
              text: 'Distribution Panels',
              children: distributionPanels
            });
          }

          if (kpiPanels.length) {
            kpiPanels.sort(sortFunc);
            data.push({
              text: 'KPI Panels',
              children: kpiPanels
            });
          }

          if (summaryPanels.length) {
            summaryPanels.sort(sortFunc);
            data.push({
              text: 'Summary Panels',
              children: summaryPanels
            });
          }

          if (trendPanels.length) {
            trendPanels.sort(sortFunc);
            data.push({
              text: 'Trend Panels',
              children: trendPanels
            });
          }

          // we have to destroy and recreate the Selectr because the .add() function doesn't support "children"
          self.panelSelctr.destroy();
          self.panelSelctr = new Selectr('#panelAdv-panelSelector', {
            defaultSelected: false,
            placeholder: 'Select Panels...',
            data: data
          });

          function sortFunc(a, b) {
            if (a.text.toLowerCase() < b.text.toLowerCase()) return -1;
            if (a.text.toLowerCase() > b.text.toLowerCase()) return 1;
            return 0;
          }
        });
      }
    }
  }

  self.saveCallback = null;
}

SharePanelAdv.prototype.show = function(model) {
  var self = this;

  if (!_.has(model, 'appId')) {
    throw new Error('SharePanelAdv needs a model with an appId.');
  }
  if (!_.has(model, 'viewId')) {
    throw new Error('SharePanelAdv needs a model with an viewId.');
  }

  // not sure if I need any of these to pre-populate the advanced dialog entries
  self.appId = model.appId;
  // self.viewId = model.viewId;
  // self.currentBoard = model.currentBoard;
  // self.currentUserId = model.currentUserId;

  // TODO: Once other apps have multiple "dashboard" views, this modal should support them.
  //       Currently only historical2 has multiple dashboard views.
  self.showAppSelectr(self.appId === 'historical2');
  self.appViewData = [];
  if (self.appId === 'historical2') {
    self.appViewData = [{
        value: "historical2/historical2dashboard",
        text: "My Dashboards"
      },
      {
        value: "historical2/historical2adoption",
        text: "Adoption"
      },
      {
        value: "historical2/historical2issues",
        text: "Issues"
      },
      {
        value: "historical2/historical2capacity",
        text: "Capacity"
      },
      {
        value: "historical2/historical2roomboard",
        text: "Workspaces"
      }
    ];
  } else if (self.appId === 'rooms') {
    self.appViewData = [{
      value: "rooms/historical2roomboard",
      text: "My Dashboards"
    }];
  } else if (self.appId === 'assurance') {
    self.appViewData = [{
      value: "assurance/dashboard",
      text: "My Dashboards"
    }];
  } else {
    throw new Error('SharePanelAdv:: Unknown appId: ' + self.appId);
  }

  self.saveCallback = model.saveCallback;
  self.updateError(null);

  // not super efficient resetting and reloading all data, but works for now
  self.fromOrgSelctr.clear();
  self.fromOrgSelctr.removeAll();
  self.fromUserSelctr.clear();
  self.fromUserSelctr.removeAll();

  self.fromAppSelctr.clear();
  self.fromAppSelctr.removeAll();
  self.fromAppSelctr.add(self.appViewData);

  self.fromDashboardSelctr.clear();
  self.fromDashboardSelctr.removeAll();

  self.toOrgSelctr.clear();
  self.toOrgSelctr.removeAll();
  self.toUserSelctr.clear();
  self.toUserSelctr.removeAll();

  self.toAppSelctr.clear();
  self.toAppSelctr.removeAll();
  self.toAppSelctr.add(self.appViewData);

  self.toDashboardSelctr.clear();
  self.toDashboardSelctr.removeAll();


  DashboardService.fetchAllOrgsTemp().then(orgs => {
    _.forEach(orgs, org => {
      if (!org.deleted) {
        self.fromOrgSelctr.add({ value: org.id, text: org.id + "." + org.name })
        self.toOrgSelctr.add({ value: org.id, text: org.id + "." + org.name })
      }
    })
  });

};

SharePanelAdv.prototype.save = function() {
  let self = this;
  let fromUserId = self.fromUserSelctr.getValue();
  let fromAppId = self.showAppSelectr() ? self.fromAppSelctr.getValue() : self.appViewData[0].value;
  let fromBoard = self.fromDashboardSelctr.getValue();
  let toUserId = +self.toUserSelctr.getValue(); // "+" to convert to number
  let toAppId = self.showAppSelectr() ? self.toAppSelctr.getValue() : self.appViewData[0].value;
  let toBoards = self.toDashboardSelctr.getValue();
  let panelIds = self.panelSelctr.getValue();
  let panels = [];

  if (fromUserId && fromAppId && fromBoard && toUserId && toAppId && toBoards && toBoards.length && panelIds && panelIds.length) {
    let toAppViewArray = self.showAppSelectr() ? self.toAppSelctr.getValue().split('/') : self.appViewData[0].value.split('/');
    let appId = toAppViewArray[0];
    let viewId = toAppViewArray[1];
    panels = panelIds.map(panelId => {
      let panel = self.panelsMap[panelId];
      let newPanel = {};
      if (self.appId === 'assurance') {
        let panelOptions = {
          panel: PanelOptionsService.getPanelOptions(panel.params.options),
          params: panel.params.options
        }
        newPanel = DashboardDataService.newPanel(panelOptions);
      } else {
        // historical2 / workspace insights
        newPanel = DashboardDataService.newPanel({
          panel: panel,
          params: panel.params.options
        });
      }
      delete newPanel.autoPosition;
      return newPanel;
    });

    try {
      _.forEach(toBoards, tabId => {
        PreferenceService.addOrUpdateUserPanels(toUserId, appId, viewId, tabId, panels);
      });
      self.updateError('');
    } catch (e) {
      console.error(e);
      self.updateError('There was an error sharing panels.');
    }
  } else {
    self.updateError('Please fill in all fields.')
  }

  if (!self.hasUpdateError()) {
    self.signals.closeModal.dispatch();
    if (self.saveCallback) self.saveCallback();
  }
};

SharePanelAdv.prototype.dispose = function() {
  var self = this;
  self.signals.onShow.dispose();
  self.signals.onSave.dispose();
};

ko.components.register('share-panel-adv-modal', { viewModel: SharePanelAdv, template: templateMarkup });
